import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        url: String,
    };

    submit () {
        const categories = new URLSearchParams(new FormData(this.element)).getAll('category');

        window.location.href = `${this.urlValue}#categories=${categories.join(',')}`
    }
}
